export default __webpack_public_path__ + "static/media/dashboard.6a883cf8.svg";